import * as moment from 'moment';
import * as DateTimeModule from 'react-datetime';
import { useEffect, useRef, useState } from 'react';
import { Button, Overlay } from 'react-bootstrap';
import { ICellRendererParams } from 'ag-grid-community';
import { IOrderRequest } from '@nkr/models/order-request';
import { DatePickerPopover } from './styles';

const DateTime = (DateTimeModule as any).default;

export interface ICompletionDeadlineCellParams extends ICellRendererParams {
    onCompletionDeadlineSelected: (id: number, deadline: string) => void;
}

const CompletionDeadlineCell = (params: ICompletionDeadlineCellParams) => {
    const row: IOrderRequest = params.data;
    const displayed: string = params.value;
    const deadline = displayed !== '--' ? moment(displayed, 'MM/DD/YYYY') : null;
    const [show, setShow] = useState(false);
    const trigger = useRef(null);

    useEffect(() => {
        if (show == false) {
            return;
        }

        const close = () => setShow(false);
        params.api.addEventListener('bodyScroll', close);

        return () => params.api.removeEventListener('bodyScroll', close);
    }, [show]);

    const handleChange = (value: moment.Moment) => {
        setShow(false);

        if (deadline && value.isSame(deadline, 'day')) {
            return;
        }

        params.onCompletionDeadlineSelected(row.id, value.format('MM/DD/YYYY'));
    };

    const handleClear = () => {
        setShow(false);
        params.onCompletionDeadlineSelected(row.id, '');
    };

    return (
        <div ref={trigger}>
            {displayed}
            <Button
                bsStyle='link'
                bsSize='xs'
                onClick={(e) => {
                    e.stopPropagation();
                    setShow(!show);
                }}
            >
                <span className='glyphicon glyphicon-calendar'></span>
            </Button>
            <Overlay
                show={show}
                target={() => trigger.current}
                onHide={() => setShow(false)}
                placement='bottom'
                rootClose
            >
                <DatePickerPopover id={`completion-deadline-${row.id}`}>
                    <DateTime
                        input={false}
                        timeFormat={false}
                        dateFormat='MM/DD/YYYY'
                        value={deadline}
                        onChange={handleChange}
                    />
                    {row.completionDeadline &&
                        <Button bsSize='xs' block onClick={handleClear}>Reset to default</Button>
                    }
                </DatePickerPopover>
            </Overlay>
        </div>
    );
};

export default CompletionDeadlineCell;
